function hidetablepop() {
    var popup = document.getElementById('popup');
    animatePopupOut(popup);
    emptyPopup(popup)
}